import Autocomplete from "@material-ui/lab/Autocomplete";
import { AutocompleteValidator } from "utils/Validators/CommonValidator";
/* core components */
import React from "react";
import TextField from "@material-ui/core/TextField";
//import Validate from "utils/Validators/Validate";
import conf from "config/env.conf.js";
import getDefaultValue from "utils/DefaultValue";
/* custom components */
import useFetch from "hooks/useFetch";

const ListboxSuspendStatus = props => {
  //const [valid, setValid] = React.useState();
  const [error, setError] = React.useState(false);
  const [helperText, setHelperText] = React.useState("");
  const [isLoading, fetchData] = useFetch(
    conf.END_POINT_URL + "/suspend/suspendStatus",
    []
  );

  let content = (
    <TextField
      disabled
      label="สถานะการถูกระงับสิทธิสมัครฯ/เพิกถอนสิทธิสมัครฯ "
      margin="normal"
      fullWidth
    />
  );

  let data = [];

  if (!isLoading && fetchData !== null && fetchData.data !== undefined) {
    let newData = fetchData.data;
    if (props.flagStatus) {
      newData = newData.filter(d => d.flag === props.flagStatus);
    }
    data = newData.map(v => {
      return { id: v.suspendStatusId, value: v.detail };
    });
  }

  if (data.length > 0) {
    content = (
      <Autocomplete
        name={props.name}
        disabled={props.disabled}
        defaultValue={getDefaultValue(data, props.defaultValue)}
        value={props.value}
        // value={props.value && props.value.id === 0 ? data[0] : props.value}
        options={data}
        getOptionLabel={option => option.value}
        getOptionSelected={(option, value) => option.id === value.id}
        onChange={AutocompleteValidator(
          props.onChange,
          props.validators,
          setError,
          setHelperText
        )}
        //onChange={props.onChange}
        renderInput={params => {
          return (
            <TextField
              {...params}
              label={
                props.title
                  ? props.title
                  : "สถานะการถูกระงับสิทธิสมัครฯ/เพิกถอนสิทธิสมัครฯ"
              }
              margin="normal"
              error={error}
              fullWidth
              helperText={helperText}
            />
          );
        }}
        {...props.customProps}
      />
    );
  }
  return content;
};
export default ListboxSuspendStatus;
